import { gsap } from "gsap";
// import { ScrollBarHelper } from "exports-loader?exports=ScrollBarHelper!bootstrap/js/src/util/scrollbar";
import heightMenuMobile from './heightMenuMobile'


const menuToggle = () => {

  // const CLASS_NAME_BACKDROP = 'menu-backdrop';
  const navbarToggler = document.querySelectorAll('.toggler-menu-js');
  const header = document.getElementById('header');
  // const scrollBar = new ScrollBarHelper();


  var tl = gsap.timeline();
  tl.pause();

  navbarToggler.forEach((toggler) => {

    toggler.addEventListener('click', (e) => {
      e.preventDefault();
      heightMenuMobile();
      let menuToOpen = toggler.getAttribute('data-toggle');
      menuToOpen = document.getElementById(menuToOpen);
   
      tl
        .to([menuToOpen], {
          x: 0,
          duration: 0.4
        })


      if (tl.reversed() || tl.paused()) {
       
        // ScrollTo();
        tl.play();
        header.classList.add('menu-open');
        toggler.classList.add("is-active")
        // scrollBar.hide();
      } else {
        tl.reverse();
        // scrollBar.reset();
        header.classList.remove('menu-open');
        toggler.classList.remove("is-active")
      }
    });
  })
}

export default menuToggle;
